export default __webpack_public_path__ + "static/media/logo-1.782285b2.svg";